export default function PHP_array_search() {
  return (
    <div>
      <h1>PHP_array_search</h1>
    </div>
  );
}
